exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_object-gops.js
// module id = 62
// module chunks = 39